// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import DynamicDropdownPresentationPropsDefault from "@insite/mobius/DynamicDropdown/presentationProps";
import { IconWrapper } from '@insite/mobius/Icon';
import { xBaseTheme } from "@rc/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DynamicDropdownPresentationPropsDefault,
        cssOverrides: {
            dropdownWrapper: css`
                transition: all .2s ease;
                &[aria-expanded="true"] {
                    outline: ;
                    input {
                        outline: 0 !important;
                    }
                    > ${IconWrapper} {
                        transform: rotateX(180deg);
                    }
                    span[class^="VisuallyHiddenStyle"] {
                        width: 0;
                    }
                }
            `,
            noOptions: css`
                font-size: 14px;
                cursor: default;
            `,
        },
        iconProps: {
            size: 13,
            css: css`
                &&& {
                    top: 4px;
                    right: -1px;
                    width: 41px;
                    height: 41px;
                }
                &&&& {
                    svg {
                        width: 30px;
                        height: 30px;
                    }
                }
            `,
        },
    },
} as xBaseTheme["dynamicDropdown"];
